"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowNumericEditor_1 = require("../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var TabEditorContainer_1 = require("../../../../../../../shared/components/containers/TabEditorContainer");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var antd_1 = require("antd");
var WrapTableActions_1 = require("../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionEdit_1 = require("../../../../../../../shared/components/table_actions/TableActionEdit");
var TableActionDelete_1 = require("../../../../../../../shared/components/table_actions/TableActionDelete");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var BonusWagerOnDepositCfgEditor = /** @class */ (function (_super) {
    __extends(BonusWagerOnDepositCfgEditor, _super);
    function BonusWagerOnDepositCfgEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.key_restrictions = "restrictions";
        _this.key_freespins = "freespins";
        _this.key_zones = "zones";
        _this.columns = [
            {
                title: 'Статус игрока',
                dataIndex: _this.props.BonusTemplateCfgZones.dk_player_status_title,
                key: _this.props.BonusTemplateCfgZones.dk_player_status_title,
                width: 200,
            }, {
                title: 'Зона игрока',
                dataIndex: _this.props.BonusTemplateCfgZones.dk_player_zone_title,
                key: _this.props.BonusTemplateCfgZones.dk_player_zone_title,
                align: "center",
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 100
            }
        ];
        return _this;
    }
    BonusWagerOnDepositCfgEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_USR_BHV_A = this.props.ListPlayerBehaviorTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_usr_behaviors: data.data
            });
        });
        this.SID_CANCEL = this.props.listBonusCancelTypes.Subscribe("*", function (id, data) {
            _this.setState({
                avail_bonus_cancel_types: data.data
            });
        });
        this.SID_DEBIT = this.props.listBonusDebitTypes.Subscribe("*", function (id, data) {
            _this.setState({
                avail_bonus_debit_types: data.data
            });
        });
        this.SID_PERMISSION = this.props.listBonusActivationTypes.Subscribe("*", function (id, data) {
            _this.setState({
                avail_bonus_permission_types: data.data
            });
        });
        this.SID_WITHDRAW = this.props.listBonusWithdrawTypes.Subscribe("*", function (id, data) {
            _this.setState({
                avail_bonus_withdraw_types: data.data
            });
        });
        this.SID_GAMESET = this.props.listGameSet.Subscribe("*", function (id, data) {
            _this.setState({
                avail_gamesets: data.data
            });
        });
        this.SID_FSRANGE = this.props.listFSRanges.Subscribe("*", function (id, data) {
            _this.setState({
                avail_fsranges: data.data
            });
        });
        this.SID_GAMESET_GAMES = this.props.listGameSetGames.Subscribe("*", function (id, data) {
            _this.setState({
                avail_gameset_games: data.data
            });
        });
        this.SID_ZONES_A = this.props.ListGameProviderZonesAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_gws_zones: data.data
            });
        });
        this.SID_ZONES_L = this.props.BonusTemplateCfgZones.Subscribe("*", function (id, data) {
            _this.setState({
                zones_list: data.data
            });
        });
        if (this.props.record) {
            this.props.data.LoadData(this.props.record.key, function () {
                _this.setState({
                    is_bonus_create_on_deposit_number: _this.props.data.DATA.is_bonus_create_on_deposit_order_number,
                    bonus_deposit_number_to_create: _this.props.data.DATA.bonus_deposit_order_number_to_create,
                    bonus_deposit_percent_value: _this.props.data.DATA.bonus_deposit_percent_value,
                    bonus_wager_multiplier: _this.props.data.DATA.bonus_wager_multiplier,
                    bonus_min_deposit_amount_to_create: _this.props.data.DATA.bonus_min_deposit_amount_to_create,
                    bonus_up_to_withdraw_amount_limit: _this.props.data.DATA.bonus_up_to_withdraw_amount_limit,
                    is_bonus_has_up_to_withdraw_amount_limit: _this.props.data.DATA.is_bonus_has_up_to_withdraw_amount_limit,
                    bonus_up_to_bonus_amount_limit: _this.props.data.DATA.bonus_up_to_bonus_amount_limit,
                    is_bonus_has_up_to_bonus_amount_limit: _this.props.data.DATA.is_bonus_has_up_to_bonus_amount_limit,
                    bonus_up_to_bet_amount_limit: _this.props.data.DATA.bonus_up_to_bet_amount_limit,
                    is_bonus_has_up_to_bet_amount_limit: _this.props.data.DATA.is_bonus_has_up_to_bet_amount_limit,
                    bonus_cancel_type_code: _this.props.data.DATA.bonus_cancel_type_code,
                    bonus_cancel_type_title: _this.props.data.DATA.bonus_cancel_type_title,
                    bonus_debit_type_code: _this.props.data.DATA.bonus_debit_type_code,
                    bonus_debit_type_title: _this.props.data.DATA.bonus_debit_type_title,
                    bonus_permission_type_code: _this.props.data.DATA.bonus_activation_type_code,
                    bonus_permission_type_title: _this.props.data.DATA.bonus_activation_type_title,
                    bonus_withdraw_type_code: _this.props.data.DATA.bonus_withdrawal_type_code,
                    bonus_withdraw_type_title: _this.props.data.DATA.bonus_withdrawal_type_title,
                    avail_bonus_debit_types: [],
                    avail_bonus_cancel_types: [],
                    avail_bonus_withdraw_types: [],
                    avail_bonus_permission_types: [],
                    avail_gamesets: [],
                    avail_gameset_games: [],
                    is_deposit_allowed: _this.props.data.DATA.is_bonus_deposit_allowed,
                    on_deposit_add_bonus_balance_percent: _this.props.data.DATA.on_deposit_add_percent_value_on_bonus_balance,
                    on_deposit_add_bonus_wagering_percent: _this.props.data.DATA.on_deposit_add_percent_value_on_bonus_wagering,
                    is_bonus_auto_complete: _this.props.data.DATA.is_auto_complete_bonus,
                    freespin_gameset_id: _this.props.data.DATA.freespin_gameset_id,
                    freespin_gameset_title: _this.props.data.DATA.freespin_gameset_title,
                    is_freespin_pre_selected_game: _this.props.data.DATA.is_freespin_pre_selected_game,
                    freespin_game_id: _this.props.data.DATA.freespin_game_id,
                    freespin_game_title: _this.props.data.DATA.freespin_game_title,
                    freespin_count: _this.props.data.DATA.freespin_count,
                    is_freespin_pre_selected_bet: _this.props.data.DATA.is_freespin_pre_selected_bet,
                    freespin_bet: _this.props.data.DATA.freespin_bet,
                    is_freespin_pre_selected_denomination: _this.props.data.DATA.is_freespin_pre_selected_denomination,
                    freespin_denomination: _this.props.data.DATA.freespin_denomination,
                    is_freespin_pre_selected_multiplier: _this.props.data.DATA.is_freespin_pre_selected_multiplier,
                    freespin_multiplier: _this.props.data.DATA.freespin_multiplier,
                    is_freespin_pre_selected_lines: _this.props.data.DATA.is_freespin_pre_selected_lines,
                    freespin_lines: _this.props.data.DATA.freespin_lines,
                    is_bonus_required_payment_tag_to_create: _this.props.data.DATA.is_bonus_required_payment_tag_to_create,
                    is_bonus_required_any_payment_tag_except_entered_to_create: _this.props.data.DATA.is_bonus_required_any_payment_tag_except_entered_to_create,
                    bonus_payment_tag_value: _this.props.data.DATA.bonus_payment_tag_value,
                    is_bonus_limit_max_deposit_amount_to_create: _this.props.data.DATA.is_bonus_limit_max_deposit_amount_to_create,
                    bonus_max_deposit_amount_to_create: _this.props.data.DATA.bonus_max_deposit_amount_to_create,
                    is_bonus_has_fsrange: _this.props.data.DATA.is_bonus_has_fsrange,
                    bonus_fsrange_id: _this.props.data.DATA.bonus_fsrange_id,
                    bonus_fsrange_title: _this.props.data.DATA.bonus_fsrange_title,
                    avail_fsranges: [],
                    is_custom_gws_zone: _this.props.data.DATA.is_custom_gws_zone,
                    custom_gws_zone_id: _this.props.data.DATA.custom_gws_zone_id,
                    custom_gws_zone_title: _this.props.data.DATA.custom_gws_zone_title,
                    is_override_gws_player_zone: _this.props.data.DATA.is_override_gws_player_zone,
                    avail_gws_zones: [],
                    is_active_bonus_has_expiration: _this.props.data.DATA.is_active_bonus_has_expiration,
                    bonus_expiration_action_code: _this.props.data.DATA.bonus_expiration_action_code,
                    bonus_expiration_action_title: _this.props.data.DATA.bonus_expiration_action_title,
                    // bonus_expiration_action_rules: IInputRulesState;
                    active_bonus_expiration_ttl_hours: _this.props.data.DATA.active_bonus_expiration_ttl_hours,
                    is_bonus_has_up_to_withdraw_multiplier_limit: _this.props.data.DATA.is_bonus_has_up_to_withdraw_multiplier_limit,
                    bonus_up_to_withdraw_multiplier_limit: _this.props.data.DATA.bonus_up_to_withdraw_multiplier_limit,
                    avail_usr_behaviors: [],
                    zones_list: [],
                    tabKey: _this.key_main
                }, function () {
                    _this.LoadTypes(true);
                });
            });
        }
        else {
            this.setState({
                is_bonus_create_on_deposit_number: false,
                bonus_deposit_number_to_create: 1,
                bonus_deposit_percent_value: 100,
                bonus_wager_multiplier: 30,
                bonus_min_deposit_amount_to_create: 100,
                bonus_up_to_withdraw_amount_limit: 10000,
                is_bonus_has_up_to_withdraw_amount_limit: false,
                bonus_up_to_bonus_amount_limit: 10000,
                is_bonus_has_up_to_bonus_amount_limit: false,
                bonus_up_to_bet_amount_limit: 10000,
                is_bonus_has_up_to_bet_amount_limit: false,
                avail_bonus_debit_types: [],
                avail_bonus_cancel_types: [],
                avail_bonus_permission_types: [],
                avail_bonus_withdraw_types: [],
                avail_gamesets: [],
                avail_gameset_games: [],
                bonus_cancel_type_code: 0,
                bonus_cancel_type_title: "",
                bonus_debit_type_code: 0,
                bonus_debit_type_title: "",
                bonus_permission_type_code: 0,
                bonus_permission_type_title: "",
                bonus_withdraw_type_code: 0,
                bonus_withdraw_type_title: "",
                is_deposit_allowed: false,
                on_deposit_add_bonus_balance_percent: 0,
                on_deposit_add_bonus_wagering_percent: 0,
                is_bonus_auto_complete: false,
                freespin_gameset_id: 0,
                freespin_gameset_title: "",
                is_freespin_pre_selected_game: false,
                freespin_game_id: 0,
                freespin_game_title: "",
                freespin_count: 0,
                is_freespin_pre_selected_bet: false,
                freespin_bet: 0.01,
                is_freespin_pre_selected_denomination: false,
                freespin_denomination: 0.01,
                is_freespin_pre_selected_multiplier: false,
                freespin_multiplier: 1,
                is_freespin_pre_selected_lines: false,
                freespin_lines: 1,
                is_bonus_required_payment_tag_to_create: false,
                is_bonus_required_any_payment_tag_except_entered_to_create: false,
                bonus_payment_tag_value: "",
                is_bonus_limit_max_deposit_amount_to_create: false,
                bonus_max_deposit_amount_to_create: 0,
                is_bonus_has_fsrange: false,
                bonus_fsrange_id: 0,
                bonus_fsrange_title: "",
                avail_fsranges: [],
                is_custom_gws_zone: false,
                custom_gws_zone_id: 0,
                custom_gws_zone_title: "",
                is_override_gws_player_zone: false,
                avail_gws_zones: [],
                is_active_bonus_has_expiration: false,
                bonus_expiration_action_code: 0,
                bonus_expiration_action_title: "",
                // bonus_expiration_action_rules: IInputRulesState;
                active_bonus_expiration_ttl_hours: 168,
                is_bonus_has_up_to_withdraw_multiplier_limit: false,
                bonus_up_to_withdraw_multiplier_limit: 10,
                avail_usr_behaviors: [],
                zones_list: [],
                tabKey: this.key_main
            }, function () {
                _this.LoadTypes(false);
            });
        }
        this.doReSetRules();
        this.props.state.setExtBreadCrumbPath(["\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0448\u0430\u0431\u043B\u043E\u043D\u0430 \u0431\u043E\u043D\u0443\u0441\u0430 - [" + this.props.rootRecord.title + "]"]);
    };
    BonusWagerOnDepositCfgEditor.prototype.LoadTypes = function (hasData) {
        this.props.listBonusCancelTypes.LoadData();
        this.props.listBonusDebitTypes.LoadData();
        this.props.listBonusActivationTypes.LoadData();
        this.props.listBonusWithdrawTypes.LoadData();
        this.props.listGameSet.LoadDataByBrandAndCurrency(this.props.rootRecord.brand_id, this.props.record.app_currency_id);
        this.props.ListGameProviderZonesAvail.LoadDataByBrandAndCurrency(this.props.rootRecord.brand_id, this.props.record.app_currency_id);
        this.props.listFSRanges.LoadData(this.props.rootRecord.brand_id);
        this.props.ListPlayerBehaviorTypesAvail.LoadData();
        this.props.BonusTemplateCfgZones.LoadData(this.props.record.key);
        if (hasData) {
            if (this.props.record) {
                if (this.props.rootRecord.is_use_freespin) {
                    if (this.state.freespin_gameset_id > 0) {
                        this.props.listGameSetGames.LoadDataByGameSetId(this.state.freespin_gameset_id);
                    }
                }
            }
        }
    };
    BonusWagerOnDepositCfgEditor.prototype.ComponentWillUnmount = function () {
        this.props.listBonusCancelTypes.UnSubscribe(this.SID_CANCEL);
        this.props.listBonusDebitTypes.UnSubscribe(this.SID_DEBIT);
        this.props.listBonusActivationTypes.UnSubscribe(this.SID_PERMISSION);
        this.props.listBonusWithdrawTypes.UnSubscribe(this.SID_WITHDRAW);
        this.props.listGameSet.UnSubscribe(this.SID_GAMESET);
        this.props.listGameSetGames.UnSubscribe(this.SID_GAMESET_GAMES);
        this.props.listFSRanges.UnSubscribe(this.SID_FSRANGE);
        this.props.ListGameProviderZonesAvail.UnSubscribe(this.SID_ZONES_A);
        this.props.BonusTemplateCfgZones.UnSubscribe(this.SID_ZONES_L);
        this.props.ListPlayerBehaviorTypesAvail.UnSubscribe(this.SID_USR_BHV_A);
    };
    BonusWagerOnDepositCfgEditor.prototype.doReSetRules = function () {
        this.setState({
            bonus_debit_type_rules: { isError: false },
            bonus_cancel_type_rules: { isError: false },
            bonus_permission_type_rules: { isError: false },
            bonus_withdraw_type_rules: { isError: false },
            on_deposit_add_bonus_balance_percent_rules: { isError: false },
            on_deposit_add_bonus_wagering_percent_rules: { isError: false },
            freespin_gameset_rules: { isError: false },
            freespin_game_rules: { isError: false },
            freespin_count_rules: { isError: false },
            freespin_bet_rules: { isError: false },
            freespin_denomination_rules: { isError: false },
            freespin_multiplier_rules: { isError: false },
            bonus_payment_tag_value_rules: { isError: false },
            freespin_lines_rules: { isError: false },
            bonus_max_deposit_amount_to_create_rules: { isError: false },
            bonus_fsrange_rules: { isError: false },
            custom_gws_zone_rules: { isError: false },
            bonus_expiration_action_rules: { isError: false }
        });
    };
    BonusWagerOnDepositCfgEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.bonus_debit_type_code) || (this.state.bonus_debit_type_title.length === 0)) {
            this.setState({
                bonus_debit_type_rules: { isError: true, errorMessage: "Поле [Списание ставки] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.is_deposit_allowed) {
            if ((this.state.on_deposit_add_bonus_balance_percent < 0) || (this.state.on_deposit_add_bonus_balance_percent > 1000)) {
                this.setState({
                    on_deposit_add_bonus_balance_percent_rules: { isError: true, errorMessage: "Некорректное значение % зачисления на бонусный баланс!" },
                    tabKey: this.key_additional
                });
                return false;
            }
            if ((this.state.on_deposit_add_bonus_wagering_percent < 0) || (this.state.on_deposit_add_bonus_wagering_percent > 1000)) {
                this.setState({
                    on_deposit_add_bonus_wagering_percent_rules: { isError: true, errorMessage: "Некорректное значение % зачисления в отыгрыш!" },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        if ((!this.state.bonus_cancel_type_code) || (this.state.bonus_cancel_type_title.length === 0)) {
            this.setState({
                bonus_cancel_type_rules: { isError: true, errorMessage: "Поле [Отмена бонуса] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if ((!this.state.bonus_withdraw_type_code) || (this.state.bonus_withdraw_type_title.length === 0)) {
            this.setState({
                bonus_withdraw_type_rules: { isError: true, errorMessage: "Поле [Поведение при снятии] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.bonus_permission_type_code) || (this.state.bonus_permission_type_title.length === 0)) {
            this.setState({
                bonus_permission_type_rules: { isError: true, errorMessage: "Поле [Верификация пользователя] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if (this.props.rootRecord.is_use_freespin) {
            if ((!this.state.freespin_gameset_id) || (this.state.freespin_gameset_title.length === 0)) {
                this.setState({
                    freespin_gameset_rules: { isError: true, errorMessage: "Поле [Набор игр] не заполнено!" },
                    tabKey: this.key_freespins
                });
                return false;
            }
            if (this.state.is_freespin_pre_selected_game) {
                if ((!this.state.freespin_game_id) || (this.state.freespin_game_title.length === 0)) {
                    this.setState({
                        freespin_game_rules: { isError: true, errorMessage: "Поле [игра] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if ((!this.state.freespin_count) || (this.state.freespin_count <= 0) || (this.state.freespin_count > 9999)) {
                this.setState({
                    freespin_count_rules: { isError: true, errorMessage: "Поле [кол-во фриспинов] не заполнено!" },
                    tabKey: this.key_freespins
                });
                return false;
            }
            if (this.state.is_freespin_pre_selected_bet) {
                if ((!this.state.freespin_bet) || (this.state.freespin_bet <= 0)) {
                    this.setState({
                        freespin_bet_rules: { isError: true, errorMessage: "Поле [ставка] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_freespin_pre_selected_denomination) {
                if ((!this.state.freespin_denomination) || (this.state.freespin_denomination <= 0)) {
                    this.setState({
                        freespin_denomination_rules: { isError: true, errorMessage: "Поле [деноминация] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_freespin_pre_selected_multiplier) {
                if ((!this.state.freespin_multiplier) || (this.state.freespin_multiplier <= 0)) {
                    this.setState({
                        freespin_multiplier_rules: { isError: true, errorMessage: "Поле [множитель] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_bonus_required_payment_tag_to_create) {
                if ((!this.state.bonus_payment_tag_value) || (this.state.bonus_payment_tag_value.length == 0)) {
                    this.setState({
                        bonus_payment_tag_value_rules: { isError: true, errorMessage: "Поле [тэг платежной системы] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_bonus_required_any_payment_tag_except_entered_to_create) {
                if ((!this.state.bonus_payment_tag_value) || (this.state.bonus_payment_tag_value.length == 0)) {
                    this.setState({
                        bonus_payment_tag_value_rules: { isError: true, errorMessage: "Поле [тэг платежной системы] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_freespin_pre_selected_lines) {
                if (this.state.freespin_lines < 0) {
                    this.setState({
                        freespin_lines_rules: { isError: true, errorMessage: "Поле [линии] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_bonus_limit_max_deposit_amount_to_create) {
                //bonus_max_deposit_amount_to_create_rules
                if ((!this.state.bonus_max_deposit_amount_to_create) || (this.state.bonus_max_deposit_amount_to_create <= 0)) {
                    this.setState({
                        bonus_max_deposit_amount_to_create_rules: { isError: true, errorMessage: "Поле [макс депозит] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
            if (this.state.is_bonus_has_fsrange) {
                if ((!this.state.bonus_fsrange_id) || (this.state.bonus_fsrange_title.length === 0)) {
                    this.setState({
                        bonus_fsrange_rules: { isError: true, errorMessage: "Поле [диапазон фриспинов] не заполнено!" },
                        tabKey: this.key_freespins
                    });
                    return false;
                }
            }
        }
        if (this.state.is_custom_gws_zone) {
            if ((!this.state.custom_gws_zone_id) || (this.state.custom_gws_zone_title.length === 0)) {
                this.setState({
                    custom_gws_zone_rules: { isError: true, errorMessage: "Поле зона игрового провайдера не заполнено!" },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        if (this.state.is_active_bonus_has_expiration) {
            if ((!this.state.bonus_expiration_action_code) || (this.state.bonus_expiration_action_title.length === 0)) {
                this.setState({
                    bonus_expiration_action_rules: { isError: true, errorMessage: "Поле действие при завершении бонуса не заполнено!" },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        return true;
    };
    BonusWagerOnDepositCfgEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                bonus_template_currency_config_id: this.props.record.key,
                bonus_deposit_number_to_create: this.state.bonus_deposit_number_to_create,
                bonus_deposit_percent_value: this.state.bonus_deposit_percent_value,
                bonus_min_deposit_amount_to_create: this.state.bonus_min_deposit_amount_to_create,
                is_bonus_limit_max_deposit_amount_to_create: this.state.is_bonus_limit_max_deposit_amount_to_create,
                bonus_max_deposit_amount_to_create: this.state.bonus_max_deposit_amount_to_create,
                is_bonus_has_up_to_withdraw_amount_limit: this.state.is_bonus_has_up_to_withdraw_amount_limit,
                bonus_up_to_withdraw_amount_limit: this.state.bonus_up_to_withdraw_amount_limit,
                is_bonus_has_up_to_bonus_amount_limit: this.state.is_bonus_has_up_to_bonus_amount_limit,
                bonus_up_to_bonus_amount_limit: this.state.bonus_up_to_bonus_amount_limit,
                is_bonus_has_up_to_bet_amount_limit: this.state.is_bonus_has_up_to_bet_amount_limit,
                bonus_up_to_bet_amount_limit: this.state.bonus_up_to_bet_amount_limit,
                bonus_wager_multiplier: this.state.bonus_wager_multiplier,
                is_bonus_create_on_deposit_number: this.state.is_bonus_create_on_deposit_number,
                bonus_debit_type_code: this.state.bonus_debit_type_code,
                bonus_cancel_type_code: this.state.bonus_cancel_type_code,
                bonus_activation_type_code: this.state.bonus_permission_type_code,
                bonus_withdrawal_type_code: this.state.bonus_withdraw_type_code,
                is_bonus_deposit_allowed: this.state.is_deposit_allowed,
                on_deposit_add_percent_value_on_bonus_balance: this.state.on_deposit_add_bonus_balance_percent,
                on_deposit_add_percent_value_on_bonus_wagering: this.state.on_deposit_add_bonus_wagering_percent,
                is_bonus_auto_complete: this.state.is_bonus_auto_complete,
                freespin_gameset_id: this.state.freespin_gameset_id,
                is_freespin_pre_selected_game: this.state.is_freespin_pre_selected_game,
                freespin_game_id: this.state.freespin_game_id,
                freespin_count: this.state.freespin_count,
                is_freespin_pre_selected_bet: this.state.is_freespin_pre_selected_bet,
                freespin_bet: this.state.freespin_bet,
                is_freespin_pre_selected_denomination: this.state.is_freespin_pre_selected_denomination,
                freespin_denomination: this.state.freespin_denomination,
                is_freespin_pre_selected_multiplier: this.state.is_freespin_pre_selected_multiplier,
                freespin_multiplier: this.state.freespin_multiplier,
                is_bonus_required_payment_tag_to_create: this.state.is_bonus_required_payment_tag_to_create,
                is_bonus_required_any_payment_tag_except_entered_to_create: this.state.is_bonus_required_any_payment_tag_except_entered_to_create,
                bonus_payment_tag_value: this.state.bonus_payment_tag_value,
                is_freespin_pre_selected_lines: this.state.is_freespin_pre_selected_lines,
                freespin_lines: this.state.freespin_lines,
                is_bonus_has_fsrange: this.state.is_bonus_has_fsrange,
                bonus_fsrange_id: this.state.bonus_fsrange_id,
                custom_gws_zone_id: this.state.custom_gws_zone_id,
                is_custom_gws_zone: this.state.is_custom_gws_zone,
                is_override_gws_player_zone: this.state.is_override_gws_player_zone,
                is_active_bonus_has_expiration: this.state.is_active_bonus_has_expiration,
                bonus_expiration_action_code: this.state.bonus_expiration_action_code,
                active_bonus_expiration_ttl_hours: this.state.active_bonus_expiration_ttl_hours,
                is_bonus_has_up_to_withdraw_multiplier_limit: this.state.is_bonus_has_up_to_withdraw_multiplier_limit,
                bonus_up_to_withdraw_multiplier_limit: this.state.bonus_up_to_withdraw_multiplier_limit,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Настройки бонуса с вейджером на депозит изменены!");
            });
        }
    };
    BonusWagerOnDepositCfgEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusWagerOnDepositCfgEditor.prototype.getFormTitle = function () {
        return "Изменить настройки бонуса с вейджером на депозит";
    };
    BonusWagerOnDepositCfgEditor.prototype.getActionButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusWagerOnDepositCfgEditor.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Отмена бонуса", placeholder: "Выберите тип отмены бонуса" }, value: { key: this.state.bonus_cancel_type_code, value: this.state.bonus_cancel_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_cancel_type_code: newVal.key,
                        bonus_cancel_type_title: newVal.value,
                        bonus_cancel_type_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_cancel_types, required: true, rules: this.state.bonus_cancel_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Списание ставки", placeholder: "Выберите тип списания ставки" }, value: { key: this.state.bonus_debit_type_code, value: this.state.bonus_debit_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_debit_type_code: newVal.key,
                        bonus_debit_type_title: newVal.value,
                        bonus_debit_type_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_debit_types, required: true, rules: this.state.bonus_debit_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Разрешать пополнение бонуса", value: this.state.is_deposit_allowed, onChecked: function (checked) { _this.setState({ is_deposit_allowed: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "% суммы в баланс:", placeholder: "Введите какой % от депозита зачислится на бонусный баланс" }, values: { max: 1000, min: 0, value: this.state.on_deposit_add_bonus_balance_percent }, onValueChanged: function (newVal) {
                    _this.setState({
                        on_deposit_add_bonus_balance_percent: newVal,
                        on_deposit_add_bonus_balance_percent_rules: { isError: false }
                    });
                }, disabled: !this.state.is_deposit_allowed, rules: this.state.on_deposit_add_bonus_balance_percent_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "% суммы в отыгрыш:", placeholder: "Введите какой % от депозита зачислится в отыгрыш" }, values: { max: 1000, min: 0, value: this.state.on_deposit_add_bonus_wagering_percent }, onValueChanged: function (newVal) {
                    _this.setState({
                        on_deposit_add_bonus_wagering_percent: newVal,
                        on_deposit_add_bonus_wagering_percent_rules: { isError: false }
                    });
                }, disabled: !this.state.is_deposit_allowed, rules: this.state.on_deposit_add_bonus_wagering_percent_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Активный бонус будет иметь срок действия", value: this.state.is_active_bonus_has_expiration, onChecked: function (checked) { _this.setState({ is_active_bonus_has_expiration: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "При истечении бонуса:", placeholder: "Выберите действие при истечении бонуса" }, value: { key: this.state.bonus_expiration_action_code, value: this.state.bonus_expiration_action_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_expiration_action_code: newVal.key,
                        bonus_expiration_action_title: newVal.value,
                        bonus_expiration_action_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_cancel_types, required: true, rules: this.state.bonus_expiration_action_rules, disabled: !this.state.is_active_bonus_has_expiration }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Срок жизни бонуса, час:", placeholder: "Введите срок жизни бонуса в часах" }, values: { max: 999999, min: 1, value: this.state.active_bonus_expiration_ttl_hours }, onValueChanged: function (newVal) {
                    _this.setState({
                        active_bonus_expiration_ttl_hours: newVal,
                    });
                }, disabled: !this.state.is_active_bonus_has_expiration }),
            this.getActionButtons()));
    };
    BonusWagerOnDepositCfgEditor.prototype.isUsedPaymentTag = function () {
        if (this.state.is_bonus_required_any_payment_tag_except_entered_to_create) {
            return true;
        }
        if (this.state.is_bonus_required_payment_tag_to_create) {
            return true;
        }
        return false;
    };
    BonusWagerOnDepositCfgEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бонус на номер депозита", value: this.state.is_bonus_create_on_deposit_number, onChecked: function (checked) { _this.setState({ is_bonus_create_on_deposit_number: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Номер депозита:", placeholder: "Введите номер депозита" }, values: { max: 999, min: 1, value: this.state.bonus_deposit_number_to_create }, onValueChanged: function (newVal) { _this.setState({ bonus_deposit_number_to_create: newVal }); }, disabled: !this.state.is_bonus_create_on_deposit_number }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "% от депозита в бонус:", placeholder: "Введите % от депозита для зачисления в бонус" }, values: { max: 9999, min: 1, value: this.state.bonus_deposit_percent_value }, onValueChanged: function (newVal) { _this.setState({ bonus_deposit_percent_value: newVal }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Размер вейджера:", placeholder: "Введите размер вейджера" }, values: { max: 9999, min: 1, value: this.state.bonus_wager_multiplier }, onValueChanged: function (newVal) { _this.setState({ bonus_wager_multiplier: newVal }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Поведение при снятии", placeholder: "Выберите поведение при снятии средств с баланса" }, value: { key: this.state.bonus_withdraw_type_code, value: this.state.bonus_withdraw_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_withdraw_type_code: newVal.key,
                        bonus_withdraw_type_title: newVal.value,
                        bonus_withdraw_type_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_withdraw_types, required: true, rules: this.state.bonus_withdraw_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Требование к верификации", placeholder: "Выберите поведение при активации" }, value: { key: this.state.bonus_permission_type_code, value: this.state.bonus_permission_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_permission_type_code: newVal.key,
                        bonus_permission_type_title: newVal.value,
                        bonus_permission_type_rules: { isError: false }
                    });
                }, items: this.state.avail_bonus_permission_types, required: true, rules: this.state.bonus_permission_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бонус на определенный тэг платежной системы", value: this.state.is_bonus_required_payment_tag_to_create, onChecked: function (checked) {
                    _this.setState({ is_bonus_required_payment_tag_to_create: checked }, function () {
                        if (_this.state.is_bonus_required_payment_tag_to_create) {
                            _this.setState({ is_bonus_required_any_payment_tag_except_entered_to_create: false });
                        }
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бонус на любой тэг платежной системы кроме указанного", value: this.state.is_bonus_required_any_payment_tag_except_entered_to_create, onChecked: function (checked) {
                    _this.setState({ is_bonus_required_any_payment_tag_except_entered_to_create: checked }, function () {
                        if (_this.state.is_bonus_required_any_payment_tag_except_entered_to_create) {
                            _this.setState({ is_bonus_required_payment_tag_to_create: false });
                        }
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тэг платежной системы:", placeholder: "Введите тэг платежной системы" }, value: this.state.bonus_payment_tag_value, onValueChanged: function (newVal) { _this.setState({ bonus_payment_tag_value: newVal, bonus_payment_tag_value_rules: { isError: false } }); }, required: this.state.is_bonus_required_payment_tag_to_create, rules: this.state.bonus_payment_tag_value_rules, disabled: !this.isUsedPaymentTag() }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать отдельную зону провайдера", value: this.state.is_custom_gws_zone, onChecked: function (checked) { _this.setState({ is_custom_gws_zone: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Зона провайдера", placeholder: "Выберите зону провайдера" }, value: { key: this.state.custom_gws_zone_id, value: this.state.custom_gws_zone_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        custom_gws_zone_id: newVal.key,
                        custom_gws_zone_title: newVal.value,
                        custom_gws_zone_rules: { isError: false }
                    });
                }, items: this.state.avail_gws_zones, required: this.state.is_custom_gws_zone, disabled: !this.state.is_custom_gws_zone, rules: this.state.custom_gws_zone_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Переопределять зону игрока (если есть) (кроме стриммеров)", value: this.state.is_override_gws_player_zone, onChecked: function (checked) { _this.setState({ is_override_gws_player_zone: checked }); }, disabled: !this.state.is_custom_gws_zone }),
            this.getActionButtons()));
    };
    BonusWagerOnDepositCfgEditor.prototype.getRestrictionEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Ограничивать максимальную сумму снятия при отыгрыше", value: this.state.is_bonus_has_up_to_withdraw_amount_limit, onChecked: function (checked) { _this.setState({ is_bonus_has_up_to_withdraw_amount_limit: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма снятия:", placeholder: "Введите максимальную сумму снятия" }, values: { max: 999999999, min: 1, value: this.state.bonus_up_to_withdraw_amount_limit }, onValueChanged: function (newVal) { _this.setState({ bonus_up_to_withdraw_amount_limit: newVal }); }, disabled: !this.state.is_bonus_has_up_to_withdraw_amount_limit }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Ограничивать максимальную сумму снятия при отыгрыше множителем от депозита ", value: this.state.is_bonus_has_up_to_withdraw_multiplier_limit, onChecked: function (checked) { _this.setState({ is_bonus_has_up_to_withdraw_multiplier_limit: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс множитель:", placeholder: "Введите максимальное значение множителя" }, values: { max: 999999999, min: 1, value: this.state.bonus_up_to_withdraw_multiplier_limit }, onValueChanged: function (newVal) { _this.setState({ bonus_up_to_withdraw_multiplier_limit: newVal }); }, disabled: !this.state.is_bonus_has_up_to_withdraw_multiplier_limit }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Ограничивать максимальную сумму бонуса", value: this.state.is_bonus_has_up_to_bonus_amount_limit, onChecked: function (checked) { _this.setState({ is_bonus_has_up_to_bonus_amount_limit: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма бонуса:", placeholder: "Введите максимальную сумму бонуса" }, values: { max: 999999999, min: 1, value: this.state.bonus_up_to_bonus_amount_limit }, onValueChanged: function (newVal) { _this.setState({ bonus_up_to_bonus_amount_limit: newVal }); }, disabled: !this.state.is_bonus_has_up_to_bonus_amount_limit }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Ограничивать максимальную сумму ставки", value: this.state.is_bonus_has_up_to_bet_amount_limit, onChecked: function (checked) { _this.setState({ is_bonus_has_up_to_bet_amount_limit: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма ставки:", placeholder: "Введите максимальную сумму ставки" }, values: { max: 999999999, min: 1, value: this.state.bonus_up_to_bet_amount_limit }, onValueChanged: function (newVal) { _this.setState({ bonus_up_to_bet_amount_limit: newVal }); }, disabled: !this.state.is_bonus_has_up_to_bet_amount_limit }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Автоматически завершать бонус", value: this.state.is_bonus_auto_complete, onChecked: function (checked) { _this.setState({ is_bonus_auto_complete: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин. деп для создания:", placeholder: "Введите минимальный размер депозита для создания бонуса <" }, values: { max: 999999999, min: 1, value: this.state.bonus_min_deposit_amount_to_create }, onValueChanged: function (newVal) { _this.setState({ bonus_min_deposit_amount_to_create: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Не создавать бонус при сумме депозита более или равно чем", value: this.state.is_bonus_limit_max_deposit_amount_to_create, onChecked: function (checked) { _this.setState({ is_bonus_limit_max_deposit_amount_to_create: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс деп для создания:", placeholder: "Введите максимальную сумму депозита для создания бонуса >=" }, values: { max: 999999999, min: 1, value: this.state.bonus_max_deposit_amount_to_create }, onValueChanged: function (newVal) { _this.setState({ bonus_max_deposit_amount_to_create: newVal }); }, disabled: !this.state.is_bonus_limit_max_deposit_amount_to_create }),
            this.getActionButtons()));
    };
    BonusWagerOnDepositCfgEditor.prototype.getFreeSpinEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать диапазон фриспинов", value: this.state.is_bonus_has_fsrange, onChecked: function (checked) {
                    _this.setState({
                        is_bonus_has_fsrange: checked
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Диапазон фриспинов", placeholder: "Выберите диапазон фриспинов" }, value: { key: this.state.bonus_fsrange_id, value: this.state.bonus_fsrange_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_fsrange_id: newVal.key,
                        bonus_fsrange_title: newVal.value,
                        bonus_fsrange_rules: { isError: false },
                    });
                }, items: this.state.avail_fsranges, required: true, rules: this.state.bonus_fsrange_rules, disabled: !this.state.is_bonus_has_fsrange }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Набор игр", placeholder: "Выберите набор игр" }, value: { key: this.state.freespin_gameset_id, value: this.state.freespin_gameset_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_gameset_id: newVal.key,
                        freespin_gameset_title: newVal.value,
                        freespin_gameset_rules: { isError: false },
                        freespin_game_id: 0,
                        freespin_game_title: "",
                        freespin_game_rules: { isError: false }
                    }, function () {
                        _this.props.listGameSetGames.LoadDataByGameSetId(_this.state.freespin_gameset_id);
                    });
                }, items: this.state.avail_gamesets, required: true, rules: this.state.freespin_gameset_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заранее определенная игра", value: this.state.is_freespin_pre_selected_game, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_game: checked
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игра", placeholder: "Выберите игру" }, value: { key: this.state.freespin_game_id, value: this.state.freespin_game_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_game_id: newVal.key,
                        freespin_game_title: newVal.value,
                        freespin_game_rules: { isError: false }
                    });
                }, items: this.state.avail_gameset_games, required: this.state.is_freespin_pre_selected_game, rules: this.state.freespin_game_rules, disabled: !this.state.is_freespin_pre_selected_game }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во фриспинов:", placeholder: "Введите количество фриспинов" }, values: { max: 9999, min: 1, value: this.state.freespin_count }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_count: newVal,
                        freespin_count_rules: { isError: false }
                    });
                }, required: true, rules: this.state.freespin_count_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Предопределенная ставка", value: this.state.is_freespin_pre_selected_bet, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_bet: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Размер ставки:", placeholder: "Введите размер ставки" }, values: { max: 9999, min: 0.01, value: this.state.freespin_bet }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_bet: newVal,
                        freespin_bet_rules: { isError: false }
                    });
                }, precision: 2, disabled: !this.state.is_freespin_pre_selected_bet, rules: this.state.freespin_bet_rules, required: this.state.is_freespin_pre_selected_bet }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Предопределенная деноминация", value: this.state.is_freespin_pre_selected_denomination, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_denomination: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Размер деноминации:", placeholder: "Введите размер деноминации" }, values: { max: 9999, min: 0.01, value: this.state.freespin_denomination }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_denomination: newVal,
                        freespin_denomination_rules: { isError: false }
                    });
                }, precision: 2, disabled: !this.state.is_freespin_pre_selected_denomination, rules: this.state.freespin_denomination_rules, required: this.state.is_freespin_pre_selected_denomination }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Предопределенный множитель", value: this.state.is_freespin_pre_selected_multiplier, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_multiplier: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Размер множителя:", placeholder: "Введите размер множителя" }, values: { max: 9999, min: 1, value: this.state.freespin_multiplier }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_multiplier: newVal,
                        freespin_multiplier_rules: { isError: false }
                    });
                }, disabled: !this.state.is_freespin_pre_selected_multiplier, rules: this.state.freespin_multiplier_rules, required: this.state.is_freespin_pre_selected_multiplier }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Предопределенное кол-во линий", value: this.state.is_freespin_pre_selected_lines, onChecked: function (checked) {
                    _this.setState({
                        is_freespin_pre_selected_lines: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во линий:", placeholder: "Введите кол-во линий" }, values: { max: 9999, min: 1, value: this.state.freespin_lines }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_lines: newVal,
                        freespin_lines_rules: { isError: false }
                    });
                }, disabled: !this.state.is_freespin_pre_selected_lines, rules: this.state.freespin_lines_rules, required: this.state.is_freespin_pre_selected_lines }),
            this.getActionButtons()));
    };
    BonusWagerOnDepositCfgEditor.prototype.onDeleteClick = function (record) {
        this.props.BonusTemplateCfgZones.DeleteData({ bonus_template_currency_config_id: this.props.record.key, bonus_segment_key: record.key }, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0421\u0435\u0433\u043C\u0435\u043D\u0442 \u0431\u043E\u043D\u0443\u0441\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BonusWagerOnDepositCfgEditor.prototype.onEditClick = function (record) {
        var _this = this;
        this.props.DlgBonusTemplateCustomZoneEditor
            .SetStatuses(this.state.avail_usr_behaviors)
            .SetZones(this.state.avail_gws_zones)
            .SetZoneVal(record.player_zone_id)
            .SetStatusVal(record.player_status_code)
            .SetDialogTitle("Изменить сегмент бонуса")
            .SetOnNoClick(function () { _this.props.DlgBonusTemplateCustomZoneEditor.Close(); })
            .SetOnYesClick(function (statusVal, zoneVal) {
            _this.props.BonusTemplateCfgZones.EditData({
                bonus_segment_key: record.key,
                bonus_template_currency_config_id: _this.props.record.key,
                player_status_code: statusVal,
                player_zone_id: zoneVal
            }, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0421\u0435\u0433\u043C\u0435\u043D\u0442 \u0431\u043E\u043D\u0443\u0441\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D"));
            });
        })
            .Show();
    };
    BonusWagerOnDepositCfgEditor.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.props.BonusTemplateCfgZones.LoadData(this.props.record.key);
        }
        if (action === "create") {
            this.props.DlgBonusTemplateCustomZoneEditor
                .SetStatuses(this.state.avail_usr_behaviors)
                .SetZones(this.state.avail_gws_zones)
                .SetDialogTitle("Добавить сегмент бонуса")
                .SetOnNoClick(function () { _this.props.DlgBonusTemplateCustomZoneEditor.Close(); })
                .SetOnYesClick(function (statusVal, zoneVal) {
                _this.props.BonusTemplateCfgZones.AddData({
                    bonus_template_currency_config_id: _this.props.record.key,
                    player_status_code: statusVal,
                    player_zone_id: zoneVal
                }, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0421\u0435\u0433\u043C\u0435\u043D\u0442 \u0431\u043E\u043D\u0443\u0441\u0430 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D"));
                });
            })
                .Show();
        }
    };
    BonusWagerOnDepositCfgEditor.prototype.getSegmentsEditContent = function () {
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.zones_list, pagination: {}, scroll: { x: true } })));
    };
    BonusWagerOnDepositCfgEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        if (this.state.tabKey == this.key_restrictions) {
            return this.getRestrictionEditContent();
        }
        if (this.state.tabKey == this.key_freespins) {
            return this.getFreeSpinEditContent();
        }
        if (this.state.tabKey == this.key_zones) {
            return this.getSegmentsEditContent();
        }
        return null;
    };
    BonusWagerOnDepositCfgEditor.prototype.getTabsArray = function () {
        var _ret = [];
        _ret.push({ key: this.key_main, tab: "Основные" });
        _ret.push({ key: this.key_additional, tab: "Дополнительно" });
        _ret.push({ key: this.key_restrictions, tab: "Ограничения" });
        if (this.props.rootRecord.is_use_freespin) {
            _ret.push({ key: this.key_freespins, tab: "Фриспины" });
        }
        _ret.push({ key: this.key_zones, tab: "Сегментация бонуса" });
        return _ret;
    };
    BonusWagerOnDepositCfgEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 900, activeTabKey: this.state.tabKey, tabs: this.getTabsArray(), onTabChange: function (key) { _this.setState({ tabKey: key }); } }, this.getContent()));
    };
    return BonusWagerOnDepositCfgEditor;
}(React.Component));
exports.default = BonusWagerOnDepositCfgEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/wager_on_dep/BonusWagerOnDepositCfgEditor.tsx
// module id = 1912
// module chunks = 0